module.exports = __webpack_public_path__ + "static/img/s72.1d01ad2c.png";